import React, { useEffect, useRef, useState } from 'react';
import {
  TestimonialsContainer,
  TestimonialsWrapper,
  TestimonialCard,
  TestimonialText,
  Author,
  FadeInSection
} from './TestimonialsElements';

const Testimonials = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const target = sectionRef.current; // ✅ Referenz sichern

    if (!target) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.2 }
    );

    observer.observe(target);

    return () => {
      observer.unobserve(target); // ✅ kein Zugriff mehr auf sectionRef.current
    };
  }, []);

  return (
    <TestimonialsContainer id="testimonials" ref={sectionRef}>
      <h2>Was unsere Kunden sagen</h2>
      <FadeInSection isVisible={visible}>
        <TestimonialsWrapper>
          <TestimonialCard>
            <TestimonialText>
              „Dank Software Solution läuft unsere gesamte IT stabil und ohne Ausfälle – wir können uns endlich wieder auf unser Kerngeschäft konzentrieren.“
            </TestimonialText>
            <Author>– Geschäftsführung eines regionalen Handelsunternehmens</Author>
          </TestimonialCard>

          <TestimonialCard>
            <TestimonialText>
              „Sehr schnelle Reaktionszeiten, klare Kommunikation und faire Preise. Für uns die perfekte IT-Betreuung.“
            </TestimonialText>
            <Author>– Inhaber eines mittelständischen Dienstleistungsbetriebs</Author>
          </TestimonialCard>

          <TestimonialCard>
            <TestimonialText>
              „Von der Beratung bis zur Umsetzung alles top. Besonders die flexible Unterstützung bei Notfällen hat uns überzeugt.“
            </TestimonialText>
            <Author>– Praxismanagerin einer Arztordination</Author>
          </TestimonialCard>
        </TestimonialsWrapper>
      </FadeInSection>
    </TestimonialsContainer>
  );
};

export default Testimonials;
